const S_IN_M = 60;
const S_IN_H = 3600;
const M_IN_H = 60;

/**
 * Format duration into H:MM:SS format without leading zeros for hours.
 * e.g. 1:03:02 for 1 hour, 3 minutes, 2 seconds
 */
export default function formatTooltipDuration(seconds = 0): string {
  if (seconds < 0) seconds = 0;

  const hours = Math.floor(seconds / S_IN_H);
  const minutes = Math.floor((seconds / S_IN_M) % M_IN_H);
  const secs = Math.floor(seconds % S_IN_M);

  if (hours > 0) {
    return `${hours}:${String(minutes).padStart(2, '0')}:${String(
      secs
    ).padStart(2, '0')}`;
  }

  return `${minutes}:${String(secs).padStart(2, '0')}`;
}
